export default "__VITE_ASSET__d5ce9ed2__"